module.exports = __webpack_public_path__ + "img/restricted-icon.be490728.png";